import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProposalRouterSelectors } from '@lockton-apps/shared/data-access/router';

import {
  SHARED_PROPOSALS_FEATURE_KEY,
  SharedProposalsState,
  proposalsAdapter,
} from './proposals.reducer';

// Lookup the 'Shared Proposals' feature state managed by NgRx
const selectSharedProposalsState = createFeatureSelector<SharedProposalsState>(
  SHARED_PROPOSALS_FEATURE_KEY
);

const { selectAll: selectAllConstructor, selectEntities } =
  proposalsAdapter.getSelectors();

export const selectAll = createSelector(
  selectSharedProposalsState,
  (state: SharedProposalsState) => selectAllConstructor(state)
);

export const selectProposals = createSelector(
  selectSharedProposalsState,
  (state: SharedProposalsState) => selectEntities(state)
);

export const selectProposal = createSelector(
  selectProposals,
  ProposalRouterSelectors.selectRoutedId,
  (entities, id) => (id ? entities[id] : undefined)
);

export const selectQueriedProposal = createSelector(
  selectProposals,
  ProposalRouterSelectors.selectRoutedId,
  (entities, id) => (id ? entities[id] : undefined)
);

export const selectProposalsError = createSelector(
  selectSharedProposalsState,
  (state: SharedProposalsState) => state.error
);

export const selectProposalUpdating = createSelector(
  selectSharedProposalsState,
  (state: SharedProposalsState) => state.updating
);

export const selectProposalLoaded = createSelector(
  selectSharedProposalsState,
  (state: SharedProposalsState) => state.loaded
);

export const selectApplication = createSelector(selectProposal, (proposal) =>
  proposal ? proposal.formData : null
);
